import GuidedHighlightingTextSelectionMenu from "./GuidedHighlightingTextSelectionMenu";

export default GuidedHighlightingTextSelectionMenu;
